import { tableFeatures } from "@tanstack/react-table";

// Tanstack Table 9 requires a features table option. However, in our faciliteiten tables we render a table but don't use any table functionality (with the exception of the vestigingen beheer table). Hence the empty features object.

export const faciliteitenTableFeatures = tableFeatures({});

export type FaciliteitenTableFeatures = typeof faciliteitenTableFeatures;
